import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LoginComponent} from './login.component';
import {NzButtonModule, NzFormModule, NzInputModule, NzMessageService, NzIconModule, NzSpinModule, NzAlertModule} from 'ng-zorro-antd';
import {RouterModule} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

@NgModule({
  declarations: [LoginComponent],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    NzFormModule,
    NzInputModule,
    NzButtonModule,
    ReactiveFormsModule,
    NzIconModule,
    NzSpinModule,
    NzAlertModule,
  ],
  providers: [NzMessageService]
})
export class LoginModule {
}
